import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Button, Modal, Count, Loading } from '../../components/all'
import useAulaStore from '../../store/useAulaStore'
import useUserStore from '../../store/useUserStore'
import toast from '../../utils/toast'

export default function SelectTypeView() {
  //#region Lógica
  const navigate = useNavigate()
  const updateAula = useAulaStore.getState().updateAula
  const resetAula = useAulaStore.getState().resetAula

  const { usuario } = useUserStore()
  const [categorias, setCategorias] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedType, setSelectedType] = useState(null)

  const categoriasEscrito = {
    A: 'Moto',
    B: 'Carro',
    C: 'Caminhão',
    D: 'Ônibus'
  }

  const iconsButton = {
    A: 'two_wheeler',
    B: 'directions_car',
    C: 'local_shipping',
    D: 'directions_bus',
    E: 'local_shipping'
  }

  useEffect(() => {
    const fetchCategorias = async () => {
      setLoading(true)
      try {
        const categoriasData = usuario.categoria_pretendida
        if (categoriasData.length > 0) {
          setCategorias(categoriasData.split('').map(char => char.toUpperCase()))
        } else {
          showToast('Nenhum Resultado', 'Nenhuma categoria encontrada.')
        }
      } catch (error) {
        showToast('Erro', 'Ocorreu um erro ao buscar as categorias.')
        console.error(error)
      } finally {
        setLoading(false)
      }
    }

    resetAula()
    fetchCategorias()
  }, [usuario, resetAula])

  const showToast = (title, message) => {
    toast.dismiss()
    toast.error(`${title}: ${message}`, { position: 'top-center' })
  }

  const handleButtonClick = (value) => {
    setSelectedType(value)
    setModalVisible(true)
  }

  const confirmSelection = () => {
    setModalVisible(false)
    updateAula('tipo', selectedType.toUpperCase())
    updateAula('aluno_id', usuario.usuario_id)
    updateAula('autoescola_id', usuario.autoescola_id)
    navigate('/selecionarInstrutor')
  }

  const onCancel = () => {
    setModalVisible(false)
    setSelectedType(null)
  }

  const renderCategoriaItem = (item) => (
    <div
      key={item}
      onClick={() => handleButtonClick(item)}
      className="
        flex bg-white shadow-sm p-4 rounded-xl
        border border-gray-200 gap-4 cursor-pointer
        hover:shadow-md hover:border-primary transition
      "
    >
      <div className="flex items-center justify-center w-16 sm:w-20 border-r border-gray-300">
        <span className="text-3xl sm:text-5xl font-bold">{item}</span>
      </div>

      <div className="flex flex-col flex-1 justify-between">
        <div className="flex items-center gap-2">
          <h1 className="font-semibold text-lg">
            {categoriasEscrito[item] || item}
          </h1>
          <span className="material-icons text-primary">
            {iconsButton[item] || ''}
          </span>
        </div>

        <Button className="mt-3 w-fit" type={1}>
          Selecionar
          <span className="material-icons">arrow_forward_ios</span>
        </Button>
      </div>
    </div>
  )
  //#endregion

  return (
    <div className="flex flex-col gap-6 p-4 w-full min-h-screen min-h-[100dvh] items-center justify-start sm:justify-center pt-6 pb-24">
      <div className="text-center px-2">
        <h1 className="text-2xl font-bold">Selecionar Tipo</h1>
        <p className="text-gray-600">Clique no tipo da aula que deseja marcar</p>
      </div>

      <Loading visible={loading} />

      {categorias.length === 0 ? (
        <div className="flex flex-col items-center gap-2 text-red-700">
          <span className="material-icons text-3xl">error</span>
          <p>Nenhuma categoria encontrada, entre em contato com o suporte!</p>
        </div>
      ) : (
        <div className="flex flex-col gap-3 w-full max-w-[800px] max-h-[45dvh] sm:max-h-[400px] overflow-y-auto pb-1">
          {categorias.map(renderCategoriaItem)}
        </div>
      )}

      <Count num={1} />

      <Modal isOpen={modalVisible}>
        <p>
          Você tem certeza que deseja selecionar o tipo:{' '}
          <strong>{categoriasEscrito[selectedType]}</strong>
        </p>

        <div className="flex gap-3 mt-4 justify-center">
          <Button onClick={confirmSelection} type={4}>
            Sim
            <span className="material-icons">check</span>
          </Button>

          <Button onClick={onCancel} type={3}>
            Não
            <span className="material-icons">close</span>
          </Button>
        </div>
      </Modal>

      <ToastContainer />
    </div>
  )
}
